<template>
  <div class="po-module-icon wo-app-icon">
    <po-slot-switcher :value="moduleIcon">

      <!-- Oil can -->
      <svg xmlns="http://www.w3.org/2000/svg" :viewBox="viewBox" :class="figureClasses" slot="oil-can">
        <defs>
            <linearGradient id="m-gra-1" x1="70.87" y1="126.99" x2="68.97" y2="24.22" gradientUnits="userSpaceOnUse">
                <stop offset="0" :stop-color="primaryColor"/>
                <stop offset="1" :stop-color="secondaryColor"/>
            </linearGradient>
            <linearGradient id="m-gra-2" x1="67.89" y1="127.04" x2="65.99" y2="24.28" xlink:href="#m-gra-1"/>
            <linearGradient id="m-gra-3" x1="90.03" y1="75.29" x2="90.03" y2="58.8" gradientUnits="userSpaceOnUse">
                <stop offset="0" :stop-color="primaryColor"/>
                <stop offset="1" :stop-color="primaryColor" stop-opacity="0"/>
            </linearGradient>
        </defs>
        <path fill="url(#m-gra-1)" d="M94.25,40H51.83A3,3,0,0,0,49,42.14L31.39,100.69A15,15,0,0,0,45.75,120H88.17a3,3,0,0,0,2.88-2.14l17.56-58.55A15,15,0,0,0,94.25,40ZM92.73,59.56,87.61,77c-11.55,0-20.12-10.9-16.8-22H89.32A3.56,3.56,0,0,1,92.73,59.56Z"/>
        <path fill="url(#m-gra-2)" d="M74.69,20H59.31a5,5,0,0,0-4.79,3.56l-2,6.58A3,3,0,0,0,55.43,34H75a3,3,0,0,0,2.88-2.14l1.63-5.42A5,5,0,0,0,74.69,20Z"/>
        <path fill="url(#m-gra-3)" d="M84.61,55h4.71a3.56,3.56,0,0,1,3.41,4.56L87.61,77h15.71l5.29-17.65A15,15,0,0,0,94.25,40H74.84s-2.06,7.3-4,15Z"/>
      </svg>

      <!-- Map pin -->
      <svg xmlns="http://www.w3.org/2000/svg" :viewBox="viewBox" :class="figureClasses" slot="pin">
        <defs>
        <linearGradient id="gradient" x1="70" y1="115.64" x2="70" y2="19.21" gradientUnits="userSpaceOnUse">
          <stop offset="0" :stop-color="primaryColor"/>
          <stop offset="1" :stop-color="secondaryColor"/>
        </linearGradient>
        </defs>
        <path fill="url(#gradient)" d="M70,23.86A32.63,32.63,0,0,0,37.37,56.49c0,19.79,25.6,52,31.45,59.09a1.52,1.52,0,0,0,2.36,0c5.85-7.1,31.45-39.3,31.45-59.09A32.63,32.63,0,0,0,70,23.86Zm0,46.67A13.58,13.58,0,1,1,83.58,57,13.58,13.58,0,0,1,70,70.53Z"/>
      </svg>

      <!-- Question -->
      <svg xmlns="http://www.w3.org/2000/svg" :viewBox="viewBox" :class="figureClasses" slot="question-mark">
        <defs>
        <linearGradient id="gradient" x1="70" y1="113.59" x2="70" y2="26.36" gradientUnits="userSpaceOnUse">
          <stop offset="0" :stop-color="primaryColor"/>
          <stop offset="1" :stop-color="secondaryColor"/>
        </linearGradient>
        </defs>
        <path fill="url(#gradient)" d="M70,28A37.92,37.92,0,0,0,51.26,98.89a28.71,28.71,0,0,1-4.87,10A1.92,1.92,0,0,0,48.1,112a47.4,47.4,0,0,0,23.4-8.18A37.92,37.92,0,0,0,70,28Zm-.57,60.91a5.42,5.42,0,1,1,5.41-5.42A5.42,5.42,0,0,1,69.43,88.91Zm7.95-23C75,68.1,74,69.07,74,70.68a4.6,4.6,0,0,1-9.19,0c0-5.9,3.73-9.2,6.45-11.61,2.44-2.17,3.36-3.13,3.36-4.74a3.14,3.14,0,0,0-2.34-3,5.09,5.09,0,0,0-5.73,2.16,4.6,4.6,0,0,1-7.38-5.48,14.21,14.21,0,0,1,16-5.4,12.22,12.22,0,0,1,8.64,11.68C83.84,60.23,80.11,63.53,77.38,65.94Z"/>
      </svg>

      <!-- Basket -->
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :viewBox="viewBox" :class="figureClasses" slot="basket">
        <defs>
          <linearGradient id="m-gra-1" x1="71.36" y1="132.79" x2="69.45" y2="30.03" gradientUnits="userSpaceOnUse">
            <stop offset="0" :stop-color="primaryColor"/>
            <stop offset="1" :stop-color="secondaryColor"/>
          </linearGradient>
          <linearGradient id="m-gra-2" x1="57.76" y1="133.05" x2="55.86" y2="30.28" xlink:href="#m-gra-1"/>
        </defs>
        <path fill="url(#m-gra-1)" d="M117.39,54.5H22.61a5,5,0,0,0-4.79,6.44L21.75,74a5,5,0,0,0,4.79,3.56H95.26a5.15,5.15,0,0,1,5.19,4.51,5,5,0,0,1-5,5.49H34.86A3,3,0,0,0,32,91.46l4.91,16.35A15,15,0,0,0,51.25,118.5h39.5a12.31,12.31,0,0,0,11.79-8.77l3.69-12.32,1.79-6h0l4.16-13.86h0a6.72,6.72,0,0,0,6.43-4.79l3.57-11.87A5,5,0,0,0,117.39,54.5Z"/>
        <path fill="url(#m-gra-2)" d="M53.61,48.5H74.82L50,23.7a7.5,7.5,0,0,0-10.6,10.6Z"/>
      </svg>

      <!-- Download -->
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :viewBox="viewBox" :class="figureClasses" slot="download">
        <defs>
          <linearGradient id="m-gra-1" x1="71.38" y1="126.16" x2="69.48" y2="23.4" gradientUnits="userSpaceOnUse">
            <stop offset="0" :stop-color="primaryColor"/>
            <stop offset="1" :stop-color="secondaryColor"/>
          </linearGradient>
          <linearGradient id="m-gra-2" x1="71.7" y1="126.16" x2="69.8" y2="23.39" xlink:href="#m-gra-1"/>
        </defs>
        <path fill="url(#m-gra-1)" d="M117.39,46.6H22.61A5,5,0,0,0,17.82,53L34,107a5,5,0,0,0,4.79,3.57h62.38A5,5,0,0,0,106,107l16.2-54A5,5,0,0,0,117.39,46.6ZM85.44,79.85,72.22,94.39a3,3,0,0,1-4.44,0L54.56,79.85a3,3,0,0,1,2.22-5H62v-10a3,3,0,0,1,3-3H75a3,3,0,0,1,3,3v10h5.22A3,3,0,0,1,85.44,79.85Z"/>
        <rect fill="url(#m-gra-2)" x="32.5" y="29.4" width="75" height="10" rx="5"/>
      </svg>

      <!-- Cabin -->
       <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :viewBox="viewBox" :class="figureClasses" slot="cabin">
        <defs>
          <linearGradient id="m-gra-1" x1="48.05" y1="122.04" x2="46.15" y2="19.28" gradientUnits="userSpaceOnUse">
            <stop offset="0" :stop-color="primaryColor"/>
            <stop offset="1" :stop-color="secondaryColor"/>
          </linearGradient>
          <linearGradient id="m-gra-2" x1="67.91" y1="49.21" x2="120.57" y2="48.57" xlink:href="#m-gra-1"/>
          <linearGradient id="m-gra-3" x1="68.17" y1="70.11" x2="120.82" y2="69.48" xlink:href="#m-gra-1"/>
          <linearGradient id="m-gra-4" x1="68.42" y1="91.17" x2="121.07" y2="90.54" xlink:href="#m-gra-1"/>
        </defs>
        <path fill="url(#m-gra-1)" d="M31.27,40.66V99.34a5,5,0,0,0,2.54,4.35l21.42,12.1a5,5,0,0,0,7.46-4.36V28.57a5,5,0,0,0-7.46-4.36L33.81,36.31A5,5,0,0,0,31.27,40.66Z" />
        <path fill="url(#m-gra-2)" d="M101.23,56.5H68.73v-15h32.5a7.5,7.5,0,0,1,7.5,7.5h0A7.5,7.5,0,0,1,101.23,56.5Z" />
        <path fill="url(#m-gra-3)" d="M86.23,77.5H68.73v-15h17.5a7.5,7.5,0,0,1,7.5,7.5h0A7.5,7.5,0,0,1,86.23,77.5Z" />
        <path fill="url(#m-gra-4)" d="M96.23,98.5H68.73v-15h27.5a7.5,7.5,0,0,1,7.5,7.5h0A7.5,7.5,0,0,1,96.23,98.5Z" />
      </svg>

      <!-- Partner plan -->
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :viewBox="viewBox" :class="figureClasses" slot="partner-plan">
        <defs>
           <linearGradient id="m-gra-1" x1="70.59" y1="119.8" x2="68.69" y2="17.03" gradientUnits="userSpaceOnUse">
              <stop offset="0" :stop-color="primaryColor"/>
              <stop offset="1" :stop-color="secondaryColor"/>
          </linearGradient>
        </defs>
        <path fill="url(#m-gra-1)" d="M72.2,24.59a2.83,2.83,0,0,0-4.4,0c-7.73,9.52-33.24,42.48-33.24,63.06a35.43,35.43,0,0,0,14.79,28.81h.16c.91-2.08,5.69-12.54,12.25-18.2a2.82,2.82,0,0,0-.36-4.53,16.53,16.53,0,1,1,17.26,0,2.83,2.83,0,0,0-.42,4.56c6.55,5.66,11.34,16.12,12.25,18.2h.16a35.43,35.43,0,0,0,14.79-28.81C105.44,67.07,79.93,34.11,72.2,24.59Z" />
      </svg>

    </po-slot-switcher>
  </div>
</template>
<script>

import { mapState } from 'vuex'

export default {
  name: 'PoModuleIcon',
  props: {
    value: Object
  },
  computed: mapState({
    env: state => state.environment.current,
    moduleIcon () {
      return this.value && this.value.icon ? this.value.icon : 'oil-can'
    },
    viewBox () {
      return '0 0 140 140'
    },
    figureClasses () {
      return 'wo-app-icon__figure'
    },
    primaryColor () {
      return this.env.primaryColor
    },
    secondaryColor () {
      return this.env.secondaryColor
    }
  })
}
</script>

<style lang="scss">
  .po-module-icon .wo-app-icon__figure {
    height: 3.5rem;
  }
</style>
